import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {HtmlParse} from 'utils';
import PubSub from 'services/PubSub';
import style from './style.scss';//NOSONAR

const TooltipFoodCertificate = (props) => {
    const tooltip = useRef(null);
    const flag = useRef(null);
    const arrow = useRef(null);
    const [action, setAction] = useState([]);
    const [show, setShow] = useState(false);
    const disableTooltip = props.disabled;

    

    useEffect(() => {
        setAction(action.concat([PubSub.register('tooltip_food_certificates', _closeTooltip)]));

        if(typeof window !== 'undefined'){
            window.addEventListener('resize', () => onClick(null));
        }

        return function cleanup() {
            action.map(token => PubSub.unregister(token));
            window.removeEventListener('resize', onClick);
        }
    }, [])

    const onClick = (arg) => {

        if(disableTooltip) return false;

        PubSub.dispatch('tooltip_food_certificates');
        if(arg) setShow(!show);

        const pageContainer = props.getContainerRef();

        if(tooltip && tooltip.current && pageContainer){
            const $flag = flag.current;
            const flagSize = $flag.getBoundingClientRect();
            const $tooltip = tooltip.current;
            const tooltipSize = $tooltip.getBoundingClientRect();
            const contentSize = pageContainer.getBoundingClientRect();
            let posX = flagSize.x - contentSize.x;
            const maxX = contentSize.width - tooltipSize.width;
            const $arrowUp = arrow.current;
            const posArrowX = posX;

            if(posX > maxX) {
                posX = maxX
            }

            $tooltip.style.left = posX + 'px';
            $arrowUp.style.left = posArrowX + 'px';
        }
    }

    const _closeTooltip = () => {
        setShow(false);
    }
    
    return(
        <div className='tooltip-food-certificate-wrapper'  onClick={onClick} ref={flag}>
            {props.children && (typeof props.children === 'function' ? props.children(show) : props.children)}
            <div className={'tooltip-food-certificate-arrow-up ' + ((show) ? ' visible' : '')} ref={arrow}></div>
            <div className={'tooltip-content' + ((show) ? ' visible' : '')} ref={tooltip} >
                <div className="tooltip-content-message-wrap">
                    <span className='tooltip-message'>{props.message ? HtmlParse(props.message) : ''}</span>
                </div>
                <button className='font-icn jumbo-icon-new-close'></button>
            </div>
        </div>
    )
}

TooltipFoodCertificate.propTypes = {
    getContainerRef: PropTypes.func,
    message: PropTypes.string,
}

export default TooltipFoodCertificate;
